export enum SatelliteLockStateDevice {
    ACTIVE = 'active',
    INACTIVE = 'inactive',
    IN_MAINTENANCE = 'in_maintenance'
}

